<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="signup-modal">
          <el-tabs @tab-click="backToSignIn()" v-model="activeName"  type="border-card">
            <!-- Sign Up Tab -->
            <el-tab-pane class="tab"  label="Sign In" name="first">
              <div v-if="login && !loggingIn && !signInAsGuest" class="sign-container">
                <p v-if="newPasswordResetMessage !== ''" class="old-migration">Your password has been successfully reset.</p>
                <p class="old-migration">Asian Food Grocer has a new look! If you're coming from our old site, please reset your password below.</p>
                <p v-if="loginErrorMessage" class="invalid-credentials">
                  {{ loginErrorMessage }}
                </p>
                <el-form class="form-container" :model="signUpForm" @keyup.enter.native="Login(signUpForm)">
                  <el-input :style="'border-radius:7px;'" placeholder="Email Address" class="signup-modal-input" v-model="signUpForm.username"></el-input>
                  <el-input :style="'border-radius:7px;'" placeholder="Password" class="signup-modal-input" v-model="signUpForm.password" type="password"></el-input>
                </el-form>
                <div class="text-center">
                  <p @click="ForgotPassword" class="pointer" >{{ $t('forgotPassword') }}</p>
                  <p @click="guestSignUp" class="pointer" >Checkout as Guest</p>
                  <p>
                    <button class="signin" @click="Login(signUpForm)">{{ $t('signIn') }}</button>
                  </p>
                </div>
              </div>
              <div class="sign-container" v-else-if="loggingIn">
                <loading />
              </div>
              <div v-else-if="!login && !showModal && !showChangeToNewPassword && !signInAsGuest" class="sign-container">
                <div class="text-center">
                  <h4 class="business-header">{{ $t('resetPassword') }}</h4>
                  <p class="business-info">{{ $t('resetSendEmail') }}</p>
                  <p class="business-info">{{ $t('resetSendEmailSpam') }}</p>
                  <p v-if="couldNotFindEmail" style="color: red">{{ $t('noAccountWithEmail') }}</p>
                </div>
                <el-form class="form-container" label-width="80px">
                  <el-input class="register-modal-input" @keyup.native.enter="resetEmailRequest(email, $event)" placeholder="Email" v-model="email"></el-input>
                  <input :style="'display: none'"></input>
                </el-form>
                <div class="text-center">
                  <p @click="ForgotPassword" class="pointer" >Back to Sign In</p>
                  <p>
                    <button class="signin" @click="resetEmailRequest(email, $event)">{{ $t('submit') }}</button>
                  </p>
                </div>
              </div>
              <transition name="modal" v-else-if="showModal && !login">
                <div class="sign-container">
                  <div class="form-container">
                    <p>We have sent a verification code to the desired email address.</p>
                    <p>Please enter your verification code and create a new password.</p>
                    <p v-if="verificationCodeFail">{{ $t('codeNoMatch') }}</p>
                    <p v-if="resetPasswordErrors.length" style='padding-bottom: 20px'>
                    <ul style="color: red">
                      <li v-for="error in resetPasswordErrors">{{ error }}</li>
                    </ul>
                  </p>
                  <el-form class="reset-password-form" :model="resetPasswordForm">
                    <!-- <el-input class="register-modal-input" autofocus=true placeholder="Verification Code" v-model="resetPasswordForm.verification"></el-input>
                    <el-input class="register-modal-input" autofocus=true placeholder="New Password" type='password' v-model="resetPasswordForm.newPassword"></el-input>
                    <el-input class="register-modal-input" autofocus=true placeholder="Confirm New Password" type='password' v-model="resetPasswordForm.confirmNewPassword"></el-input> -->
                    <p style="font-size: 15px; margin-bottom: 5px; margin-left: 28px;">{{ $t('verification_code') }}: </p><el-input class="register-modal-input" autofocus=true placeholder="Verification Code" v-model="resetPasswordForm.verification"></el-input>
                    <p style="font-size: 15px; margin-bottom: 5px; margin-left: 28px;">{{ $t('new_password') }}: </p><el-input class="register-modal-input" autofocus=true placeholder="New Password" type='password' v-model="resetPasswordForm.newPassword"></el-input>
                    <p style="font-size: 15px; margin-bottom: 5px; margin-left: 28px;">{{ $t('confirm_password') }}: </p><el-input class="register-modal-input" autofocus=true placeholder="Confirm New Password" type='password' v-model="resetPasswordForm.confirmNewPassword"></el-input>
                  </el-form>
                    <div class="button-container">
                      <el-button class="cancel-verification" @click="cancelEnteringVerificationCode">{{ $t('cancel') }}</el-button>
                      <el-button class="send-verification" @click="resetPasswordRequest(resetPasswordForm)">{{ $t('submit') }}</el-button>
                    </div>
                  </div>
                </div>
              </transition>
              <div class="sign-container" v-else-if="login && signInAsGuest && !showModal && !loggingIn ">
                <div class="form-container">
                  <p class="business-header" :style="'padding-bottom: 10px'">Enter Email Address to Sign in as Guest</p>
                  <p class="business-header-note">Please use a valid email in order to track and check your order status.</p>
                  <p v-if="guestCheckoutErrors.length" class="guestCheckout-container">
                    <ul class="guestCheckout-errors">
                      <li v-for="error in guestCheckoutErrors">{{ error }}</li>
                    </ul>
                  </p>
                  <el-input :style="'border-radius:7px;'" placeholder="Email" class="signup-modal-input" v-model="guestSignUpEmail" ></el-input>
                  <p @click="guestSignUp" class="pointer" >Back to Sign In</p>
                  <el-button class="signin" @click="guestLogIn()">{{ $t('submit') }}</el-button>
                </div>
              </div>
            </el-tab-pane>
            <!-- B2C Register Tab -->
            <el-tab-pane label="Register" name="second">
              <div class="sign-container">
                <el-form v-if="!registered && !registering" class="register-container" @keyup.enter.native="register(registerForm)" :model="registerForm">
                  <p v-if="errors.length" style='padding-bottom: 20px; width: 90%'>
                    <b>{{ $t('followingErrors') }}</b>
                    <ul style="color: red">
                      <li v-for="error in errors">{{ error }}</li>
                    </ul>
                  </p>
                  <div class="name-container">
                    <el-input class="register-modal-first" placeholder="First Name" v-model="registerForm.FirstName" ></el-input>
                    <el-input class="register-modal-last" placeholder="Last Name" v-model="registerForm.LastName" ></el-input>
                  </div>
                  <el-input class="register-modal-input" placeholder="Email Address" v-model="registerForm.username" ></el-input>
                  <el-input class="register-modal-input" placeholder="Password" v-model="registerForm.password" type="password" >
                  </el-input>
                  <div class="password-input">
                    <el-input class="register-modal-input" placeholder="Confirm Password" v-model="registerForm.confirmPassword" type="password"></el-input>
                  </div>
                  <el-button class="register-button" type="submit" @click="register(registerForm)">
                     Create an Account
                  </el-button>
                </el-form>
                <el-form v-if="registering && !registered" >
                  <loading />
                </el-form>
              </div>
            </el-tab-pane>
            <el-tab-pane label="Register for a Business Account" name="third">
              <div v-if="!businessRegistrationSuccessful && !businessRegistrationLoading" element-loading-spinner="spinner" class="sign-container">
                <div class="business-header-container">
                  <h4 class="business-header">Enter your Business Info</h4>
                  <p class="business-info">
                    Tell us a little about your business so we can verify it. Have multiple locations? Use the address shown on official documents like tax forms. 
                  </p>
                </div>
                <el-form class="register-container" :model="businessForm" @keyup.enter.native="businessRegister(businessForm)">
                  <p v-if="businessErrors.length || businessRegistrationError" style='padding-bottom: 20px'>
                    <b>{{ $t('followingErrors') }}</b>
                    <ul style="color: red">
                      <li>{{ businessRegistrationError }}</li>
                      <li v-for="error in businessErrors">{{ error }}</li>
                    </ul>
                  </p>
                    <div class="name-container">
                      <el-input class="register-modal-first" placeholder="First Name*" v-model="b2bFirstName" ></el-input>
                      <el-input class="register-modal-last" placeholder="Last Name*" v-model="b2bLastName" ></el-input>
                    </div>
                      <el-input class="register-modal-input" placeholder="Business Name*" v-model="businessForm.business_name" ></el-input>
                      <el-input class="register-modal-input" placeholder="Business Email*" v-model="businessForm.email" ></el-input>
                      <el-input class="register-modal-input" placeholder="Business Phone*" v-model="businessForm.phone_number" ></el-input>
                      <el-input class="register-modal-input" placeholder="Address*" v-model="businessForm.street" ></el-input>
                    <div class="name-container">
                      <el-input class="register-modal-first" placeholder="City*" v-model="businessForm.city" ></el-input>
                      <el-input class="register-modal-last" placeholder="Apt/Suite/Unit (Optional)" v-model="businessForm.suit_unit"></el-input>
                    </div>
                    <div class="name-container">
                      <el-input class="register-modal-first" placeholder="Zipcode*" v-model="businessForm.zipcode" ></el-input>
                      <el-input class="register-modal-last" placeholder="Country*" v-model="businessForm.country" ></el-input>
                    </div>
                    <el-input class="register-modal-input" placeholder="State*" v-model="businessForm.state" ></el-input>
                    <div class="business-container">
                      <div class="business-type">
                        <el-form-item class="business-select">
                          <el-select v-model="businessForm.business_type" v-bind:placeholder="$t('Type of Business')" value="">
                            <el-option
                              v-for="item in businessTypes"
                              :key="item.value"
                              :label="item.label"
                             :value="item.value"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      <el-input class="business-select" v-model="businessForm.ein" autocomplete="new-password" placeholder="Federal Tax ID Number">C</el-input>
                      <!-- <el-input class="business-select" autocomplete="new-password" v-model="businessForm.ssn" v-else placeholder="Social Security Number">else</el-input> -->
                    </div>
                    <el-form-item class="biz-container">
                      <div class="select-container">
                        <p class="business-select">Are you a retailer?</p>
                        <el-radio-group  v-model="businessForm.is_retailer">
                          <el-radio :label="true">Yes</el-radio>
                          <el-radio :label="false">No</el-radio>
                        </el-radio-group>
                      </div>
                      <el-input :style="'marginBottom: 10px'" autocomplete="new-password" v-if="businessForm.is_retailer" v-model="businessForm.resale_no" placeholder="Resale License Number"></el-input>
                    </el-form-item>
                    <div>
                      <el-form-item class="biz-container" autocomplete="new-password">
                        <div class="select-container">
                          <el-input class="business-select" v-model="businessForm.dun_brad_no" placeholder="Dun & Bradstreet Number (Optional)"></el-input>
                          <el-input class="business-select" autocomplete="new-password" v-model="businessForm.business_year" placeholder="Years in Business"></el-input>
                        </div>
                      </el-form-item>
                    </div>
                  </div>
                  <p class="terms-conditions">
                    By submitting and creating this business account, you agree to the Asian Food Grocer Business Account Terms and Conditions.
                  </p>
                  <el-button class="register-button" type="submit" @click="businessRegister(businessForm)">
                    Create Business Account
                  </el-button>
                </el-form>
              </div>
              <div v-else-if="businessRegistrationLoading && !businessRegistrationSuccessful">
                <loading />
              </div>
              <div v-else-if="businessRegistrationSuccessful && !businessRegistrationLoading" class="sign-container">
                <div class="business-header-container">
                  <h4 class="business-header">We're verifying your info</h4>
                  <p class="business-info">
                    It takes 24 hours to verify your business info. We will email you soon. Thank you.
                  </p>
                  <img class="business-image" src="../../assets/img/Asset_1@2x.png" />
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import { isUserAuthenticated } from '../../store/modules/cart';
import loading from '../loading';
export default {
  name: 'confirmation',
  components: {
    loading
  },
  data() {
    return {
      retailer: false,
      businessType: '',
      errors: [],
      businessErrors: [],
      guestCheckoutErrors: [],
      signUpForm: {
        username: '',
        password: '',
      },
      registerForm: {
        FirstName: '',
        LastName: '',
        email: '',
        password:'',
        username: '',
        confirmPassword: '',
      },
      businessForm: {
        full_name: '',
        business_name: '',
        phone_number: '',
        street: '',
        email: '',
        suit_unit: '',
        zipcode: '',
        country: '',
        state: '',
        business_type: '',
        ein: '',
        ssn: '',
        is_retailer: '',
        resale_no: '',
        dun_brad_no: '',
      },
      b2bFirstName: '',
      b2bLastName: '',
      email:'',
      login: true, // true showlogin; false forget password
      showModal: false,
      showChangeToNewPassword: false,
      newPasswordResetMessage: '',
      verification: '',
      tempToken: '',
      newpassword: '',
      couldNotFindEmail: false,
      verificationCodeFail: false,
      activeName: 'first',
      validPasswords: false,
      signInAsGuest: false,
      guestSignUpEmail: '',
      resetPasswordErrors: [],
      resetPasswordForm: {
        newPassword: '',
        confirmNewPassword: '',
        verification: '',
      },
      businessTypes: [
        { value: 'C-Corp', label: "C-Corp" },
        { value: 'S-Corp', label: "S-Corp" },
        { value: 'LLC', label: "LLC" },
        { value: 'Sole Proprietor', label: "Sole Proprietor" },
      ]
    }
  },
  methods: {
    ...mapActions('auth', ['LoginRequest', 'checkUsername', 'resetEmail', 'sentVerificationCode', 'resetPassword', 'registerBusinessCustomer', 'checkEmail', 'registerRequest', 'guestCheckout']),
    ...mapMutations('auth', ['userRegistered', 'registeringUser', 'registerError']),
    ForgotPassword() {
      this.newPasswordResetMessage = '',
      this.login = !this.login
    },
    guestSignUp() {
      this.signInAsGuest = !this.signInAsGuest;
    },
    Login(form) {
      this.LoginRequest(form);
    },
    backToSignIn() {
      if (this.activeName === 'first') {
        this.signInAsGuest = false;
        this.showModal = false;
        this.showChangeToNewPassword = false;
        this.login = true;
      }
    },
    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    resetEmailRequest(email, e) {
      e.preventDefault();
      this.couldNotFindEmail = false;
      this.resetEmail(email)
      .then(res => {
        this.tempToken = res.data;
        this.showModal = true;     
      })
      .catch(err => {
        this.couldNotFindEmail = true;
      })
    },
    resetPasswordRequest: async function(form) { 
      await this.checkPasswordForm(form);
      if (!this.resetPasswordErrors.length) {
        this.resetPassword({new_password: form.newPassword, token: this.tempToken, code: form.verification})
        .then(res => {
          console.log("res:", res)
          Object.assign(this.$data, this.$options.data.call(this));
          this.newPasswordResetMessage = "You have successfully reset your password";
        })
        .catch(err => {
          this.resetPasswordErrors = [];
          this.resetPasswordErrors.push(err);
          // alert('Error resetting your password, please contact Truckxi for more information')
        })
      }
    },
    register: async function(form) {
      form.email = this.registerForm.username;
      await this.checkForm(form);
      if(!this.errors.length) {
        this.registeringUser();
        this.registerRequest(form)
        .then(res => {
          this.userRegistered();
          this.LoginRequest({username: form.username, password: form.password});
        })
        .catch( err => {
          this.registerError();
          this.errors = [];
          this.errors.push(this.$t('errorCreateAccount'));
        })
      }
    },
    businessRegister: async function(form) {
      if (!form.is_retailer) {
        delete form.is_retailer
      }
      form.full_name = this.b2bFullName;
      await this.checkBusinessRegistration(form);
      if(!this.businessErrors.length) {
        this.registerBusinessCustomer(form)
        .catch( err => {
          this.businessErrors = [];
          this.businessErrors.push(this.$t('errorCreateAccount'));
        })
      }
    }, 
    checkPasswordForm: async function(form){
      this.resetPasswordErrors = [];
      if (form.newPassword.length < 8) {
        this.resetPasswordErrors.push(this.$t('passwordLengthRequired'))
      }
      if (form.newPassword !== form.confirmNewPassword) {
        this.resetPasswordErrors.push('Your passwords do not match.');
      }
      if (form.verification.length < 6) {
        this.resetPasswordErrors.push('Your verification code should be 6 digits in length.')
      }
      if (form.verification.length > 6) {
        this.resetPasswordErrors.push('Your verification code should be 6 digits in length.')
      }
    },
    checkForm: async function (form) {
      this.errors = [];
      const usernameBeenTaken = await this.checkUsername({ username: form.username });
      if(!form.FirstName) {
      this.errors.push(this.$t('firstNameRequired'))
      };
      if(!form.LastName) {
        this.errors.push(this.$t('lastNameRequired'))
      };
      if(form.password.length < 8) {
        this.errors.push(this.$t('passwordLengthRequired'))
      }
      if(form.username.length < 5) {
        this.errors.push(this.$t('usernameLengthRequired'));
      }
      if(usernameBeenTaken.data.isTaken) {
        this.errors.push(this.$t('usernameTaken'))
      }
      if (!this.validPasswords) {
        this.errors.push('Your passwords do not match.')
      }
      if (!form.username) {
        this.errors.push(this.$t('emailRequired'));
      } else if (!this.validEmail(form.username)) {
        this.errors.push(this.$t('emailValidRequired'));
      }else {
        const res = await this.checkEmail({ email: form.username })
        if(res.data.isTaken) {
          this.errors.push(this.$t('emailIsTaken'))
        }
      } 
    },
    checkBusinessRegistration: async function(form) {
      // const emailBeenTaken = await this.checkUsername({ username: form.email });
      this.businessErrors = [];
      if(!this.b2bFirstName) {
        this.businessErrors.push(this.$t('firstNameRequired'));
      };
      if(!this.b2bLastName) {
        this.businessErrors.push(this.$t('lastNameRequired'));
      };
       if(!form.business_name) {
        this.businessErrors.push(this.$t('Business Name required'))
      };
      if(!form.phone_number) {
        this.businessErrors.push(this.$t('Please enter a valid phone number.'))
      };
      if (!form.street) {
        this.businessErrors.push('Please enter a valid address');
      }
      if (!form.city) {
        this.businessErrors.push('Please enter a valid city');
      }
      if (!form.zipcode) {
        this.businessErrors.push('Please enter a valid zipcode');
      }
      if (!form.country) {
        this.businessErrors.push('Please enter a valid country');
      }
      if (!form.state) {
        this.businessErrors.push('Please enter a valid state');
      }
      // if (!form.business_type) {
      //   this.businessErrors.push('Please select a valid business type.')
      // }
      if (!form.ein) {
        this.businessErrors.push("Please enter a Federal Tax ID Number.")
      }
      // if ((form.business_type !=="C-Corp" && !form.ssn) || (form.business_type !== "C-Corp" && form.ssn.length !== 9)) {
      //   this.businessErrors.push("Please enter a valid Social Security Number.")
      // }
      // if (form.is_retailer === '') {
      //   this.businessErrors.push("Please select a valid retailer option.")
      // }
      if (form.is_retailer && !form.resale_no) {
        this.businessErrors.push("Please enter a valid Resale License Number.")
      }
      if (form.dun_brad_no.length && form.dun_brad_no.length !== 9) {
        this.businessErrors.push("Dun & Bradstreet numbers must be 9 digits.")
      }
      if (!form.business_year) {
        this.businessErrors.push("Please enter a valid year amount.")
      }
      if (!form.email) {
        this.businessErrors.push(this.$t('emailRequired'));
      } else if (!this.validEmail(form.email)) {
        this.businessErrors.push(this.$t('emailValidRequired'));
      }else {
        const res = await this.checkEmail({ email: form.email })
        if(res.data.isTaken) {
          this.businessErrors.push(this.$t('emailTaken'))
        }
      }
    },
    verifyPasswords(password1, password2) {
      if (password1 === password2) {
        this.validPasswords = true;
      } else {
        this.validPasswords = false;
      }
    },
    sendVerificationCode(code) {
      this.verificationCodeFail = false;
      if(code.length < 6) {
        return;
      }
      this.sentVerificationCode({code, token: this.tempToken})
      .then(res=> {
        this.showModal = false;
        this.tempToken = res.data;
        this.showChangeToNewPassword = true;
      })
      .catch(err => {
        this.verificationCodeFail = true
      })
    },
    cancelEnteringVerificationCode() {
      this.showModal = false
    },
    guestLogIn() {
      const emailBeenTaken = this.checkUsername({ username: this.guestSignUpEmail })
      .then( (response) => {
        if (!response.data.isTaken) {
          let data = {email: this.guestSignUpEmail, username: this.guestSignUpEmail}
          this.guestCheckout(data)
          .then( (res) => {
            this.LoginRequest({username: this.guestSignUpEmail, password: res.data });
          })
          .catch( (err) => {
            if (err.response.data.username) {
              if (Array.isArray(err.response.data.username)) {
                err.response.data.username.map(error => {
                  this.guestCheckoutErrors.push(error)
                })
              } else {
                this.guestCheckoutErrors.push(err.response.data.username)
              }
            } else {
              this.guestCheckoutErrors.push(err);
            }
          })
        } else {
          if (!this.guestCheckoutErrors.includes('You have previously placed an order with this email. Please sign in or reset this password.')) {
            this.guestCheckoutErrors.push('You have previously placed an order with this email. Please sign in or reset this password.')
          }
        }
      })  
    }
  },
  computed: mapState({
    businessRegistrationLoading: state => state.auth.businessRegistrationLoading,
    businessRegistrationSuccessful: state => state.auth.businessRegistrationSuccessful,
    businessRegistrationError: state => state.auth.businessRegistrationError,
    loginErrorMessage: state => state.auth.loginErrorMessage,
    loggingIn: state => state.auth.loggingIn,
    b2bFullName() {
      return this.b2bFirstName + ' ' + this.b2bLastName;
    },
    registering: state => state.auth.registering,
    registered: state => state.auth.registered,
  }),
  watch: {
    'registerForm.password': function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.verifyPasswords(this.registerForm.password, this.registerForm.confirmPassword);
      }
    },
    'registerForm.confirmPassword': function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.verifyPasswords(this.registerForm.password, this.registerForm.confirmPassword);
      }
    },
  }
}
</script>

<style scoped lang="less">
@import "../../assets/css/signUpModal.less";
</style>



// WEBPACK FOOTER //
// src/view/Auth/signUpModal.vue